"use client";

import React, {FC} from "react";
import {Row} from "@tanstack/react-table";
import {AutoTableInterface} from "@/features/types/AutoTableInterface";
import {AlertPopup} from "@/shared/components/AlertPopup";
import {getCancelReservationAlertProps} from "@/features/services/StatusChangeService";

export interface CancelReservationActionContentProps {
    row: Row<AutoTableInterface>;
    onConfirm: () => void;
    onClose: () => void;
}

export const CancelReservationActionContent: FC<CancelReservationActionContentProps> = ({
    row,
    onConfirm,
    onClose,
}) => {
    const alertProps = getCancelReservationAlertProps({
        f_ord_num: row.original.f_ord_num,
        f_sales_user_name: row.original.f_sales_user_name,
        f_sales_dat: row.original.f_sales_dat,
    });

    return (
        <AlertPopup
            {...alertProps}
            onConfirm={onConfirm}
            onClose={onClose}
        />
    );
};
